import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Evaluation from './evaluation';
import EvaluationDetail from './evaluation-detail';
import EvaluationUpdate from './evaluation-update';
import EvaluationDeleteDialog from './evaluation-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId`} component={Evaluation} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/new`} component={EvaluationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id/edit`} component={EvaluationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id`} component={EvaluationDetail} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id/delete`} component={EvaluationDeleteDialog} />
  </>
);

export default Routes;
